import { RootState } from 'ReduxConfig/store';

export const selector = ({ places, quotations }: RootState) => ({
  countries: places.countries,
  detail: quotations.detail
});
